import { IconButton } from '@main/complykit/components/icon-button';
import { ComponentType, forwardRef, SVGProps } from 'react';

import type { IconActionProps } from './types';

export type IconActionComponentProps = IconActionProps & {
  /** Press-invoked: no event, and presses do not bubble (see actions/types.ts). */
  onClick?: () => void;
};

export const IconAction = forwardRef<HTMLElement, IconActionComponentProps>(
  ({ icon, tooltip, onClick, isLoading, isDisabled, disabledTooltip }, ref) => {
    /* No tooltip wrapper: the label rides IconButton's built-in pairing
     * (instantly, placement top). Disabled swaps the name for the reason,
     * the same contract the Button and menu seats honour. */
    return (
      <IconButton
        ref={ref}
        icon={icon as ComponentType<SVGProps<SVGSVGElement>>}
        label={isDisabled && disabledTooltip ? disabledTooltip : tooltip}
        isPending={isLoading}
        isDisabled={isDisabled}
        onPress={() => onClick?.()}
      />
    );
  },
);
